export default __webpack_public_path__ + "static/media/List-documentation.02ab8199.md";